"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullscreenViewer = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _palette = require("@artsy/palette");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Slide = require("./Slide");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FullscreenViewer =
/*#__PURE__*/
function (_Component) {
  _inherits(FullscreenViewer, _Component);

  function FullscreenViewer(props) {
    var _this;

    _classCallCheck(this, FullscreenViewer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FullscreenViewer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "slider", void 0);

    _defineProperty(_assertThisInitialized(_this), "toggleCaption", function () {
      _this.setState({
        isCaptionOpen: !_this.state.isCaptionOpen
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderImageComponents", function () {
      var images = _this.props.images;
      return (0, _map2.default)(images, function (section, i) {
        return _react.default.createElement(_Slide.Slide, {
          isCaptionOpen: _this.state.isCaptionOpen,
          section: section,
          index: i + 1,
          total: images.length,
          key: i
        });
      });
    });

    _this.state = {
      isCaptionOpen: false
    };
    return _this;
  }

  _createClass(FullscreenViewer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.slider) {
        this.slider.innerSlider.list.setAttribute("tabindex", 0);
        this.slider.innerSlider.list.focus();
      }
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        onToggleCaption: this.toggleCaption
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var sliderSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        accessibility: true,
        lazyLoad: "ondemand",
        draggable: true,
        nextArrow: _react.default.createElement(RightArrow, null),
        prevArrow: _react.default.createElement(LeftArrow, null),
        initialSlide: this.props.slideIndex
      };
      return _react.default.createElement(_react.default.Fragment, null, this.props.show && _react.default.createElement(_palette.ModalBase, {
        onClose: this.props.onClose,
        dialogProps: {
          display: "block",
          width: "100%",
          height: "100%",
          bg: "white100"
        }
      }, _react.default.createElement(_reactSlick.default, _extends({}, sliderSettings, {
        ref: function ref(slider) {
          return _this2.slider = slider;
        }
      }), this.renderImageComponents()), _react.default.createElement(_palette.Clickable, {
        onClick: this.props.onClose,
        position: "absolute",
        top: "0",
        right: "0",
        p: 2,
        style: {
          cursor: "pointer"
        }
      }, _react.default.createElement(_palette.CloseIcon, {
        width: "30",
        height: "30",
        fill: "black60"
      }))));
    }
  }]);

  return FullscreenViewer;
}(_react.Component);

exports.FullscreenViewer = FullscreenViewer;

_defineProperty(FullscreenViewer, "childContextTypes", {
  onToggleCaption: _propTypes.default.func
});

var NavArrow = (0, _styledComponents.default)(_palette.Clickable).attrs({
  display: ["none", "flex"],
  px: 3,
  py: 6
}).withConfig({
  displayName: "FullscreenViewer__NavArrow",
  componentId: "wa7mcn-0"
})(["position:absolute;top:50%;transform:translateY(-50%);justify-content:center;align-items:center;cursor:pointer;z-index:1;"]);

var LeftArrow = function LeftArrow(props) {
  return _react.default.createElement(NavArrow, {
    left: "0",
    onClick: props.onClick
  }, _react.default.createElement(_palette.ArrowLeftIcon, {
    fill: "black100",
    width: "30",
    height: "30"
  }));
};

var RightArrow = function RightArrow(props) {
  return _react.default.createElement(NavArrow, {
    right: "0",
    onClick: props.onClick
  }, _react.default.createElement(_palette.ArrowRightIcon, {
    fill: "black100",
    width: "30",
    height: "30"
  }));
};
//# sourceMappingURL=FullscreenViewer.js.map